import { render, staticRenderFns } from "./AlternativesComponent.vue?vue&type=template&id=0b8a7982"
import script from "./AlternativesComponent.vue?vue&type=script&lang=js"
export * from "./AlternativesComponent.vue?vue&type=script&lang=js"
import style0 from "./AlternativesComponent.vue?vue&type=style&index=0&id=0b8a7982&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports